<div class="dialog-header" mat-dialog-title>
  <div><h2>Local data &amp; sync</h2><p>Global platform data cached by this browser</p></div>
  <button aria-label="Close sync status" class="close-button" type="button" (click)="dialogRef.close()"><span aria-hidden="true">&times;</span></button>
</div>

<mat-dialog-content class="dialog-content">
  <div *ngIf="loading && !diagnostics" class="loading-state">Reading local sync state...</div>
  <div *ngIf="error" class="error-state">{{ error }}</div>
  <ng-container *ngIf="diagnostics">
    <div class="summary-grid">
      <div class="summary-card"><span>Service</span><strong [ngClass]="'state-' + diagnostics.state.toLowerCase()">{{ diagnostics.state }}</strong><small>{{ diagnostics.tabRole }} tab</small></div>
      <div class="summary-card"><span>Local records</span><strong>{{ diagnostics.totalRecords | number }}</strong><small>Across {{ diagnostics.tableCount }} tables</small></div>
      <div class="summary-card"><span>Ready tables</span><strong>{{ diagnostics.readyTables }} / {{ diagnostics.tableCount }}</strong><small>With validated checkpoints</small></div>
      <div class="summary-card"><span>Requests</span><strong>{{ diagnostics.activeRequests }} / {{ diagnostics.concurrencyLimit }}</strong><small>{{ diagnostics.queuedRequests }} queued</small></div>
    </div>

    <div class="status-toolbar">
      <div>
        <strong>Table status</strong>
        <span *ngIf="diagnostics.lastCompletedAt">Last completed {{ diagnostics.lastCompletedAt | date:'medium' }}</span>
        <span *ngIf="!diagnostics.lastCompletedAt">No persisted completion time yet</span>
      </div>
      <div class="toolbar-actions">
        <button mat-stroked-button type="button" [disabled]="loading || syncingAll" (click)="refresh()">{{ loading ? 'Refreshing...' : 'Refresh status' }}</button>
        <button mat-raised-button color="primary" type="button" [disabled]="syncingAll || !!repairingTable" (click)="syncNow()">{{ syncingAll ? 'Syncing...' : 'Sync now' }}</button>
      </div>
    </div>

    <div class="table-shell">
      <table>
        <thead><tr><th>Table</th><th>Status</th><th class="number-column">Local</th><th class="number-column">Server</th><th>Committed through</th><th>Last completed</th><th>Action</th></tr></thead>
        <tbody>
          <tr *ngFor="let table of diagnostics.tables; trackBy: trackTable">
            <td>
              <strong>{{ table.tableLabel }}</strong>
              <small *ngIf="table.message">{{ table.message }}</small>
              <small *ngIf="table.lastError">{{ table.lastError }}</small>
              <small *ngIf="table.pageNumber">Page {{ table.pageNumber }}<ng-container *ngIf="table.totalPages"> of {{ table.totalPages }}</ng-container></small>
            </td>
            <td><span class="status-pill" [ngClass]="statusClass(table)">{{ table.status }}</span></td>
            <td class="number-column">{{ table.recordCount | number }}</td>
            <td class="number-column">{{ table.serverRecordCount == null ? '—' : (table.serverRecordCount | number) }}</td>
            <td>{{ table.committedThrough ? (table.committedThrough | date:'medium') : '—' }}</td>
            <td>{{ table.completedAt ? (table.completedAt | date:'medium') : '—' }}</td>
            <td>
              <button *ngIf="canRepair(table)" mat-button color="primary" type="button" [disabled]="!!repairingTable || syncingAll" (click)="repair(table)">{{ repairingTable === table.tableName ? 'Repairing...' : 'Repair' }}</button>
              <span *ngIf="!canRepair(table)">—</span>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <p class="refresh-note">Live status refreshes every five seconds. Sync preserves existing cache data unless a failed table explicitly requires repair.</p>
  </ng-container>
</mat-dialog-content>
